export default __webpack_public_path__ + "static/media/information--tram-bus-stop--g1.840fc7f4.png";